<template>
  <div class="transition">
    <BasicText
      size="h5"
      class="titre-transition"
    >
      Demande de rattachement impossible
    </BasicText>
    <div class="transition-items flex flex-column flex-gap-8">
      <section>
        <BasicText
          size="body-xl"
          color="red"
        >
          L'IDCC de cette entité juridique ne rentre pas dans le périmètre d'AKTO
          <br />
          Lien :
          <BasicLink
            label="France Compétences"
            @link-click="redirectExterne('https://quel-est-mon-opco.francecompetences.fr')"
          />
        </BasicText>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { DemandeRattachementResult } from '../types'
  import { redirectExterne } from '@/features/shared/tools/url'

  defineProps<CarteProps<void, Pick<DemandeRattachementResult, 'demandeRattachementConfirmée'>>>()
  defineEmits<CarteEvents<Pick<DemandeRattachementResult, 'demandeRattachementConfirmée'>>>()
</script>

<style lang="less" scoped>
  .transition-items {
    margin: 36px 0 36px 24px;
    .alert {
      margin-top: 8px;
      margin-left: -11px;
    }
  }
</style>
